module.exports = __webpack_public_path__ + "img/envelope_icon.9db1b383.svg";